import { type FunctionalComponent, h } from '@stencil/core';
import type { labelProviderInterface } from '../../../../../LabelProviderInterface';

export interface IConversationalSearchUserMessage {
  labelProvider: labelProviderInterface;
  action: string;
  query: string;
}

export const ConversationalSearchUserMessage: FunctionalComponent<
IConversationalSearchUserMessage
> = (props) => {
    return (
      <span>{props.action || props.query}</span>
    );
};
